import { useCallback, useEffect, useState } from "react";
import { billingService } from "../services/billing.service";
import { tagOf } from "../utils/api-error";
import { SubscriptionState } from "../interfaces/billing.interface";

/**
 * A plain fetch-once hook — no polling. The poll belongs to /checkout/success
 * alone; putting it here would have /account hammering the API forever for
 * any user sitting on a past_due subscription.
 */
export const useSubscription = () => {
  const [data, setData] = useState<SubscriptionState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await billingService.getSubscription());
    } catch (err) {
      setError(tagOf(err) ?? "generic");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, error, reload: load };
};
